




































































































































































































































import { ref, defineComponent, onMounted, computed } from '@vue/composition-api';
import Apierrormessage from '@/components/Apierrormessage.vue';
import store from '@/store';

export default defineComponent({
  name: 'Onboarding',
  components: { Apierrormessage },
  setup() {
    const renderReady = ref(false);
    const apiError = ref(false);
    onMounted(async () => {
      await store.dispatch('profile/getEmployeeProfile');
      renderReady.value = true;
    });
    const skillsEmployeeProfile = computed(() => store.getters['profile/skillsEmployeeProfile']);
    return {
      renderReady,
      apiError,
      skillsEmployeeProfile,
    };
  },
});
